import SlimSelect from 'slim-select';

export class CountrySwitchController {
  private readonly languageSwitchElements: NodeListOf<HTMLOptionElement | HTMLOptGroupElement> = document.querySelectorAll('.js-languageSwitch');

  constructor() {
    if (this.languageSwitchElements) {
      this.languageSwitchElements.forEach(
        function (languageSwitchElement) {
          const options = languageSwitchElement.querySelectorAll('option');
          const select = new SlimSelect({
            select: languageSwitchElement,
            showSearch: false,
            onChange: (info: any) => {
              if (info.data.selected !== '1' && info.data.url) {
                const url = new URL(info.data.url, window.location.origin);
                const params = new URLSearchParams(window.location.search);
                if (params.has('supplierPortal')) {
                  url.searchParams.set('supplierPortal', params.get('supplierPortal') as string);
                }
                window.location.href = url.toString();
              }
            },
          });

          options.forEach((option) => {
            if (option.dataset.selected === '1') {
              select.setSelected(option.value);
            }
          });
        },
      );

    }
  }
}
